
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileViewModel } from '../../lib/models';
import { FileListComponent } from '../file-list/file-list.component';
import { DialogTopComponent } from '../dialog-top/dialog-top.component';
import { DialogBottomComponent } from '../dialog-bottom/dialog-bottom.component';
import { TranslatePipe } from '@ngx-translate/core';

export interface DialogFilesListData {
    allowUpload: boolean;
    allowDownload: boolean;
    allowDelete: boolean;

    maxTotalFiles: number;
    maxTotalBytes: number;
    allowedContentTypes: string[];

    remoteFiles: FileViewModel[];
    localFiles: FileViewModel[];
}
@Component({
    selector: 'app-dialog-files-list',
    imports: [
    DialogTopComponent,
    DialogBottomComponent,
    TranslatePipe,
    FileListComponent
],
    templateUrl: './dialog-files-list.component.html',
    styleUrl: './dialog-files-list.component.scss',
})
export class DialogFilesListComponent {
    readonly dialogRef = inject<MatDialogRef<DialogFilesListComponent>>(MatDialogRef);

    public parameters: DialogFilesListData;

    constructor() {
        const parameters = inject<Partial<DialogFilesListData>>(MAT_DIALOG_DATA);

        this.parameters = {
            allowUpload: true,
            allowDownload: false,
            allowDelete: false,
            maxTotalFiles: 3,
            maxTotalBytes: 5 * 1024 * 1024,
            allowedContentTypes: ['application/pdf'],
            remoteFiles: [],
            localFiles: [],
            ...parameters,
        };
    }

    close = (e: FileViewModel[] = []): void => {
        this.dialogRef.close(e);
    };

    onSubmit = (e?: any): void => {
        this.close(this.parameters.localFiles);
    }
}
